import { debounce } from "lodash";
import { customRef, ref } from "vue";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const useDebouncedRef = (
  initialValue: any,
  delay: number | undefined,
  immediate = false,
) => {
  const state = ref(initialValue);
  const debouncedRef = customRef((track, trigger) => ({
    get() {
      track();
      return state.value;
    },
    set: debounce(
      (value: any): void => {
        state.value = value;
        trigger();
      },
      delay,
      { leading: immediate, trailing: true },
    ),
  }));
  return debouncedRef;
};
/* eslint-enable */

// wait for a bit
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Saves buffer to a file in download folder.
 */
export const downloadFile = (filename: string, buffer: ArrayBuffer) => {
  const uint8Array = new Uint8Array(buffer);
  const downloadUrl = window.URL.createObjectURL(new Blob([uint8Array]));
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
};

/**
 * Retrieve error message from try/catch errors where you many not know the type of error.
 *
 * @param error the putative error
 * @returns the string message
 */
export function getErrorMessage(error: unknown) {
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
}

export const getChildElementIndex = (element: HTMLElement) => {
  return Array.prototype.indexOf.call(element.parentElement?.children, element);
};

export const isMacOS = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /macintosh|mac os x/i.test(userAgent);
};

export const stripTags = (input: string) => {
  const tmp = document.createElement("div");
  tmp.innerHTML = input;
  return tmp.textContent ?? tmp.innerText ?? "";
};

